import { useGroupsSelectedState } from '../store/selectors.js';
import type { RootNode } from '../types/guards/node-guards.js';
import { type InternalTreeMapData } from '../types/internal.js';
import { getFilteredNodes } from '../utils/get-filtered-nodes.js';
import { getNodesValueSum } from '../utils/get-nodes-value-sum.js';

export const useVisibleNodes = (data: InternalTreeMapData): RootNode => {
  const groupsSelected = useGroupsSelectedState();
  const selectedIds = groupsSelected.map((group) => group.id);

  const filteredNodes = getFilteredNodes(data.tree.children ?? [], selectedIds);
  const rootNodeValue = getNodesValueSum(filteredNodes);

  return {
    ...data.tree,
    children: filteredNodes,
    value: rootNodeValue,
  };
};
